var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable, makeObservable } from 'mobx';
import { MenubarUser } from './User/MenubarUser';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { runtime } from '../../classes/runtime/Runtime';
import { MenubarRight } from './Right/MenubarRight';
export class Menubar {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get app() {
        return this.parent;
    }
    isMenubarLongHovering = false;
    isTheoryButtonShowing = false;
    get solidMenubarEdit() {
        return this.menubarEdit;
    }
    get menubarUser() {
        return new MenubarUser(this);
    }
    get menubarPath() {
        return new runtime.solidPackages.Large.classes.MenubarPath(this);
    }
    get menubarProgress() {
        return new runtime.solidPackages.Large.classes.MenubarProgress(this);
    }
    get menubarRight() {
        return new MenubarRight(this);
    }
    get menubarOnlinecounter() {
        return new runtime.solidPackages.Large.classes.MenubarUseronline(this);
    }
    get menubarSpeak() {
        return new runtime.solidPackages.Large.classes.MenubarSpeak(this);
    }
    get menubarHear() {
        return new runtime.solidPackages.Large.classes.MenubarHear(this);
    }
    get menubarMobile() {
        return new runtime.solidPackages.Mobile.classes.MenubarMobile(this);
    }
    get menubarEdit() {
        return runtime.streamedPackages.Edit && new runtime.streamedPackages.Edit.classes.MenubarEdit(this);
    }
    get isMenubarPhone() {
        if (runtime.isBrowserRuntime) {
            if (runtime.solidBrowserRuntime.browserDevice.isTabletOrSmartphone)
                return true;
        }
        return false;
    }
    get isAnyDialogOpen() {
        if (this.menubarUser.dialogs.isCustomDialogOpen)
            return true;
        if (this.menubarUser.dialogs.isAnyUserDialogShown)
            return true;
        if (!runtime.availablePackages.Large)
            return false;
        if (this.menubarRight.isReportErrorModalOpen)
            return true;
        if (this.menubarRight.isAppInfoModalOpen)
            return true;
        if (this.menubarRight.isPremiumDialogShowing)
            return true;
        if (runtime.browserRuntime && runtime.browserRuntime.browserModal.isBrowserModalOpen)
            return true;
        return false;
    }
    async closeAllOpenMenus() {
        await runtime.fetchPackages.Large;
        this.menubarRight.isInfoMenuOpen = false;
        this.menubarRight.isInfoIconHovering = false;
        this.menubarRight.isAppInfoModalOpen = false;
        this.menubarPath.closeAllSteps();
        this.menubarUser.closeMenu();
        runtime.browserRuntime.browserModal.isBrowserModalOpen = false;
    }
    hoveringTimer;
    setHoveringTimer() {
        this.hoveringTimer = setTimeout(action(() => {
            this.isMenubarLongHovering = true;
            const x = runtime.streamedPackages.Lazy;
        }), 500);
    }
    removeHoveringTimer() {
        if (this.hoveringTimer) {
            clearTimeout(this.hoveringTimer);
        }
        this.isMenubarLongHovering = false;
    }
    showTheoryButton() {
        this.isTheoryButtonShowing = true;
        setTimeout(() => (this.isTheoryButtonShowing = false), 4000);
    }
}
__decorate([
    observable
], Menubar.prototype, "isMenubarLongHovering", void 0);
__decorate([
    observable
], Menubar.prototype, "isTheoryButtonShowing", void 0);
__decorate([
    memoize
], Menubar.prototype, "menubarUser", null);
__decorate([
    memoize
], Menubar.prototype, "menubarPath", null);
__decorate([
    memoize
], Menubar.prototype, "menubarProgress", null);
__decorate([
    memoize
], Menubar.prototype, "menubarRight", null);
__decorate([
    memoize
], Menubar.prototype, "menubarOnlinecounter", null);
__decorate([
    memoize
], Menubar.prototype, "menubarSpeak", null);
__decorate([
    memoize
], Menubar.prototype, "menubarHear", null);
__decorate([
    memoize
], Menubar.prototype, "menubarMobile", null);
__decorate([
    memoize,
    computed
], Menubar.prototype, "menubarEdit", null);
__decorate([
    action.bound
], Menubar.prototype, "closeAllOpenMenus", null);
__decorate([
    action.bound
], Menubar.prototype, "setHoveringTimer", null);
__decorate([
    action.bound
], Menubar.prototype, "removeHoveringTimer", null);
__decorate([
    action.bound
], Menubar.prototype, "showTheoryButton", null);
